import React, {useState, useEffect} from "react";
import {useAppDispatch, useAppSelector} from "../../utils/Hooks";
import {LoggedInView} from "../common/LoggedInView";
import {getContacts, setContacts} from "../../store/reducers/ContactsSlice";
import {useNavigate} from "react-router-dom";
import Pagination from "../common/Pagination";

interface SendEmailStep2Props {
}

//https://stackoverflow.com/questions/71369320/how-to-controling-browser-back-button-with-react-router-dom-v6
export const SendEmailStep2: React.FC<SendEmailStep2Props> = () => {

    const dispatch = useAppDispatch();
    const navigate = useNavigate();

    const contactsState = useAppSelector((state) => state.contacts);

    const [checkedContacts, setCheckedContacts] = useState<number[]>([]);
    const [page, setPage] = useState<number>(1);

    useEffect(() => {
        const initialCheckedContacts = Object.values(contactsState.contacts).flatMap(company => company.contacts.map((contact:any) => contact.id));
        setCheckedContacts(initialCheckedContacts);
    }, [contactsState.contacts]);

    useEffect(() => {
        const activeTab = JSON.parse(sessionStorage.getItem('activeTab') || '{}');
        const selectedLanguage = JSON.parse(sessionStorage.getItem('selectedLanguage') || '{}');
        const selectedIds = JSON.parse(sessionStorage.getItem('selectedIds') || '[]');
        const selectedCountry = JSON.parse(sessionStorage.getItem('selectedCountry') || '{}');
        dispatch(getContacts({
            type: activeTab.identifier,
            language: selectedLanguage.value,
            categories: selectedIds,
            country: selectedCountry.value,
            page: page
        }));
    }, [page]);

    const handleCheckboxChange = (contactId: number) => {
        if (checkedContacts.includes(contactId)) {
            setCheckedContacts(checkedContacts.filter((id) => id !== contactId));
        } else {
            setCheckedContacts([...checkedContacts, contactId]);
        }
    };

    const handleSelectAllChange = () => {

        const allContactIds = Object.values(contactsState.contacts).flatMap(company => company.contacts.map((contact:any) => contact.id));

        if (checkedContacts.length === allContactIds.length) {
            setCheckedContacts([]);
        } else {
            setCheckedContacts(allContactIds);
        }
    };

    const next = () => {

        const filteredContacts = Object.values(contactsState.contacts).flatMap(company => company.contacts).filter(contact => checkedContacts.includes(contact.id));

        dispatch(setContacts(filteredContacts));

        navigate('/send-email/3')

    };

    return (
        <LoggedInView fullWidth={false}>
            <h1>Saada E-mail</h1>
            <h2>
                <span>Vali hankijad, kellele kiri saata</span>
            </h2>
            <table className="form">
                <tr>
                    <th style={{textAlign: "left"}}>
                        <input
                            type="checkbox"
                            id="toggleAllCheckboxes"
                            checked={checkedContacts.length === contactsState.contacts.length}
                            onChange={handleSelectAllChange}
                        />
                        <label>Kõik</label>
                    </th>
                </tr>
                {contactsState?.contacts?.map((company:any, key:any) => (
                    <>
                        <tr key={key}>
                            <th style={{textAlign: "left"}}>
                                {(key + 1)}
                                <label htmlFor="vendor"> {company.company.name}</label>
                            </th>
                            <td></td>
                            <td></td>
                        </tr>
                        {company.contacts.map((contact:any, key:any) => {

                            return (<tr key={`vendor_${contact.id}`}>
                                <th style={{textAlign: "left"}}></th>
                                <td>
                                    <input
                                        className="vendorCheckbox"
                                        type="checkbox"
                                        name="vendors[]"
                                        id={`vendor_${contact.id}`}
                                        value={contact.id}
                                        checked={checkedContacts.includes(contact.id)}
                                        onChange={() => handleCheckboxChange(contact.id)}
                                    />
                                    {contact.name} ({contact.email})
                                </td>
                                <td style={{textAlign: "left"}} id={`comment_${contact.id}`}>
                                    {contact.comment}
                                </td>
                            </tr>)

                        })}
                    </>
                ))}
                <tr>
                    <th></th>
                    <td>
                        <div className="action clear">
                            <p>
                                <button onClick={next}>
                                    <span>
                                        <strong>Edasi</strong>
                                    </span>
                                </button>
                            </p>
                        </div>
                    </td>
                </tr>
            </table>
            <Pagination
                totalItems={contactsState?.pagination?.total}
                itemsPerPage={100}
                onPageChange={setPage}
                noLink={true}
            />
        </LoggedInView>
    );
};